firebird.factory('videoTestVideosService', [
    '$timeout',
    '$interval',
    '$rootScope',
    'logService',
    'configService',
    'videoGlobalService',
    function ($timeout, $interval, $rootScope, logService, configService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoTestVideosService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            // for large meeting support

            self.testvideos = null; // populate from URL param e.g., {count: 12, interval: 1000}

            self.initTestvideos = initTestvideos;
            self.testvideosShouldStopVideoPlay = testvideosShouldStopVideoPlay;
            self.testvideosStartPublish = testvideosStartPublish;
            self.testvideosStopPublish = testvideosStopPublish;
            self.testvideosStartVoiceCall = testvideosStartVoiceCall;
            self.onTestvideosStartPlay = onTestvideosStartPlay;
            self.onTestvideosStopPlay = onTestvideosStopPlay;
            self.broadcastVideoFeedCountForTestvideos = broadcastVideoFeedCountForTestvideos;
        }

        // parse the ?testvideos= URL parameter value and configure self.testvideos if needed
        function initTestvideos() {
            var value = configService.getClientValue('testvideos');
            self.testvideos = null;
            if (value) {
                var parts2 = value.split(',');
                self.testvideos = {
                    count: parseInt(parts2[0]),
                    calls: parseInt(parts2[1] || '0'),
                    plugins: [], // for SIP plugin call
                    interval: parseInt(parts2[2] || '0')
                };
            }
        }

        // in syncAttendeeListVideoMuteStates, if attendantId is not found in attendee list, then check if it should be stopped or not?
        function testvideosShouldStopVideoPlay(attendantId) {
            if (!self.testvideos) {
                return true; // no change in behavior
            } else {
                var parts2 = ('' + attendantId).split(':');
                return parts2.length == 1 || (parts2[0] == self.attendantId && !self.videoroom); // false if this is test video, and self is publishing.
            }
        }

        // called on user action to mute the self video publish.
        function testvideosStopPublish() {
            if (self.testvideos) {
                if (self.testvideos.interval1) {
                    $interval.cancel(self.testvideos.interval1);
                    delete self.testvideos.interval1;
                }
                if (self.testvideos.interval2) {
                    $interval.cancel(self.testvideos.interval2);
                    delete self.testvideos.interval2;
                }
                if (self.testvideos.stream) {
                    var videoTracks = self.testvideos.stream.getVideoTracks();
                    for (var i = 0; i < videoTracks.length; ++i) {
                        videoTracks[i].stop();
                    }
                    self.testvideos.stream = null;
                }
                if (self.testvideos.plugins.length > 0) {
                    self.testvideos.plugins.forEach(function (plugin) {
                        plugin.hangup();
                    });
                    self.testvideos.plugins.splice(0, self.testvideos.plugins.length);
                }
                var items = Object.keys(self.feeds);
                items.forEach(function (item) {
                    if (item && item.indexOf(':') >= 0 && item.startsWith(self.attendantId + ':')) {
                        self.stopVideoPlay(item);
                    }
                });
                self.broadcastVideoFeedCountForTestvideos();
            }
        }

        function onTestvideosStartPlay(count, avoidDup) {
            var interval = isNaN(self.testvideos.interval) ? 1000 : self.testvideos.interval;
            var timer = (self.testvideos.interval1 = $interval(function () {
                if (!self.testvideos.interval1) {
                    // already stopped
                    return;
                }
                if (!count--) {
                    $interval.cancel(timer);
                    delete self.testvideos.interval1;
                } else {
                    var id = self.attendantId;
                    // find an id that is not yet present in feeds
                    var findex = 1;
                    for (; self.feeds[id + ':' + findex]; ++findex) {
                        // just iterate.
                    }
                    if (avoidDup && findex > count) {
                        $interval.cancel(timer);
                        delete self.testvideos.interval1;
                        return;
                    }
                    var fid = id + ':' + findex;
                    self.startVideoPlay(fid, undefined, true);
                    self.broadcastVideoFeedCountForTestvideos();
                }
            }, interval));
        }

        function onTestvideosStopPlay(fid) {
            self.stopVideoPlay(fid);
            self.broadcastVideoFeedCountForTestvideos();
        }

        function broadcastVideoFeedCountForTestvideos() {
            if (self.testvideos) {
                var count = self.videoroom ? 1 + Object.keys(self.feeds).length : 0;
                $rootScope.$broadcast('video-feed-count', count);
            }
        }

        // called on user action to unmute the self video publish. should not be called on reconnection re-publish.
        function testvideosStartPublish(onlyPlay) {
            $timeout(function () {
                var count = self.testvideos.count;
                self.onTestvideosStartPlay(count, onlyPlay);
            }, 1000); // wait a second for initial, so that publish is done.

            if (!onlyPlay && self.testvideos.calls) {
                navigator.mediaDevices
                    .getUserMedia({ video: { width: { max: 320 }, height: { max: 180 }, frameRate: 15 } })
                    .then(function (stream) {
                        self.testvideos.stream = stream;
                        if (self.testvideos.interval) {
                            var count = self.testvideos.calls;
                            var interval = self.testvideos.interval;
                            var timer = (self.testvideos.interval2 = $interval(function () {
                                if (!count--) {
                                    $interval.cancel(timer);
                                    delete self.testvideos.interval2;
                                } else {
                                    self.testvideosStartVoiceCall(
                                        self.testvideos.calls - count,
                                        self.testvideos.stream
                                    );
                                }
                            }, interval));
                        } else {
                            for (var i = 0; i < self.testvideos.calls; ++i) {
                                self.testvideosStartVoiceCall(i + 1, stream);
                            }
                        }
                    })
                    .catch(function (error) {
                        logger.error('testvideosStartPublish', 'test failed to get user media', error);
                    });
            }
        }

        // this is asubset of startVoiceCall to connect to SIP plugin to publish video, no voice, no reconnection logic, no error checking.
        function testvideosStartVoiceCall(index, stream) {
            var plugin = null;
            self.janus.attach({
                plugin: self.newplugin ? 'janus.plugin.anymeeting' : 'janus.plugin.sip',
                handle_type: 'sip',
                opaqueId: self.opaqueId,
                success: function (pluginHandle) {
                    plugin = pluginHandle;
                    plugin.index = index;
                    self.testvideos.plugins.push(plugin);

                    var register = {
                        request: 'register',
                        type: 'guest',
                        username: self.localuri.replace(/@/, '-' + index + '@')
                    };

                    plugin.send({ message: register });
                },
                onmessage: function (msg, jsep) {
                    if (msg.error) {
                        return;
                    }

                    var result = msg.result || {};
                    var event = (msg.result && msg.result.event) || null;
                    if (event == 'registered') {
                        plugin.createOffer({
                            stream: stream,
                            success: function (jsep) {
                                var items = [];
                                var headers = { 'X-AM-SFU': 'video,test', 'X-AM-SFU-ALID': '' + self.attendantLoginId };

                                var body = {
                                    request: 'call',
                                    uri: self.remoteuri,
                                    headers: headers,
                                    autoaccept_reinvites: true
                                };

                                plugin.send({ message: body, jsep: jsep });
                            },
                            error: function (error) {}
                            // customizeSdp: function(jsep) {
                            //     // if videocodec or audiocodec is present then this will use that codec here.
                            //     self.customizeSdp(jsep, undefined, is_screen, true, false);
                            // },
                        });
                    } else if (event == 'accepted') {
                        if (jsep !== null && jsep !== undefined) {
                            //self.customizeSdp(jsep, undefined, undefined, true, true);
                            plugin.handleRemoteJsep({
                                jsep: jsep,
                                error: function () {
                                    plugin.send({ message: { request: 'hangup' } });
                                    plugin.hangup();
                                }
                            });
                        }
                    } else if (event === 'updatingcall') {
                        var doAudio = jsep.sdp.indexOf('m=audio ') > -1,
                            doVideo = jsep.sdp.indexOf('m=video ') > -1;
                        plugin.createAnswer({
                            jsep: jsep,
                            media: { audio: doAudio, video: doVideo },
                            success: function (jsep) {
                                var body = { request: 'update' };
                                plugin.send({ message: body, jsep: jsep });
                            }
                        });
                    } else if (event === 'hangup') {
                        plugin.hangup();
                    }
                },
                onlocalstream: function (stream) {
                    var audioTracks = stream.getAudioTracks();
                    plugin.muteAudio();
                    if (self.newplugin) {
                        $timeout(function () {
                            if (audioTracks && audioTracks.length > 0) {
                                audioTracks[0].stop();
                            }
                        }, 0);
                    }
                },
                onremotestream: function (stream) {}, // do nothing
                oncleanup: function () {} // do nothing
            });
        }
    }
]);
